'use client'
import { ContentBlock } from '@/globalTypes'
import React, { useEffect } from 'react'
import Devider from '../Divider';
import Link from 'next/link';
import { formatMyStringAsSlug } from '@/lib/globalHooks';
import Image from 'next/image';

const BlogContent = ({ contentBlock, index, }: { contentBlock: ContentBlock, index: number }) => {
    useEffect(() => {
        let element = document.getElementById(window.location.href.split("#").pop()!);
        element?.scrollIntoView({
            behavior: "smooth"
        })
    }, [contentBlock])
    switch (contentBlock.type) {
        case 'heading': {
            let CustomHeadingTag = `h${contentBlock.level}`;
            let heading_size = contentBlock.level === 2 ?
                `text-xl` : contentBlock.level === 3 ? `text-lg` : 'text-md';
            return (
                <>
                    {index !== 0 && contentBlock.level === 2 && <Devider />}
                    {
                        //@ts-ignore
                        <CustomHeadingTag
                            id={formatMyStringAsSlug(contentBlock.children[0].text)}
                            className={`${heading_size} font-bold my-4 text-[#1D4749]`}
                            key={contentBlock.children[0].text}
                        >
                            {contentBlock.children[0].text}
                        </CustomHeadingTag>}
                </>
            )
        }
        case 'image': {

            return (
                <div className='relative w-full flex justify-center h-[300px] max-w-[640px] overflow-hidden m-auto rounded-lg '>
                    <div
                        className="absolute inset-0  bg-center bg-no-repeat bg-cover filter blur-lg"
                        style={{ backgroundImage: `url(${contentBlock.image.url})` }}
                    />
                    <Image
                        id={formatMyStringAsSlug(contentBlock.children[0].text)}
                        className="relative z-10 object-contain rounded-[8px] w-full h-full"
                        key={contentBlock.children[0].text}
                        width={1}
                        height={1}
                        alt="infographic"
                        src={contentBlock.image.url}
                    />
                </div>
            )
        }
        case 'paragraph': {
            return <p key={contentBlock.children[0].text} className='my-1'>{
                contentBlock.children!.map((child: any) => {
                    switch (child.type) {
                        case 'text': {
                            return <span key={child.text} className={`${child.bold ? 'font-bold' : ''} break-words`}>{child.text}</span>
                        }
                        case 'link': {
                            return <span><Link key={child.text} href={child.url!} className='text-[#1D4749] font-bold break-words'>{child.children![0].text}</Link>
                            </span>
                        }
                    }

                })
            }</p>
        }
        case 'list': {
            let CustomListTag = `${contentBlock.format === 'ordered' ? 'ol' : 'ul'}`
            return (
                //@ts-ignore
                <CustomListTag key={contentBlock.children[0].text} className={`my-3 mx-6 ${contentBlock.format === 'ordered' ? 'list-decimal' : 'list-disc'} `}>
                    {
                        contentBlock.children.map((listItem: any, index: any) => {
                            return <li key={listItem.text} className='my-1'>
                                {
                                    listItem.children!.map((child: any) => {
                                        return (
                                            child.type === "text" ?
                                                (<span key={child.text} className={`${child.bold ? 'font-bold' : ''}`}>{child.text}</span>)
                                                : <span><Link key={child.text} className={`${child.children[0].bold ? 'font-bold' : ''} text-[#8a5cf5]`} target='_blank' href={child.url} >{child.children[0].text}</Link>
                                                </span>)
                                    })
                                }
                            </li>
                        })
                    }
                </CustomListTag>
            )
        }
    }
}
export default BlogContent


